module.exports = __webpack_public_path__ + "static/media/two.b44bc546.svg";